<template>
  <div :class="stockData.modal ? 'modal is-active' : 'modal'">
    <div class="modal-background"></div>
    <div class="modal-card is-small">
      <header class="modal-card-head">
        <button @click="closeModal()" class="delete" aria-label="close"></button>
        <p class="modal-card-title">We're Sorry!</p>  
      </header>
      
      <section class="modal-card-body has-text-centered ph15">
       <template>
          <img src="@/assets/img/icon-basket.svg" alt="Basket" class="mt20 mb20">
          <p class="is-size-14 mb10 mb15" v-html="stockData.message"></p>
       </template>
      </section>

      <footer class="modal-card-foot">
        <div class="next-prev-button" >
          <button class="button is-large is-primary is-full-width" @click.prevent="closeModal()">Continue Shopping</button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoLongerOnStock',
  data() {
    return {
      stockData: {
        modal: false,
        message: '',
      },
    };
  },

  mounted() {
    bus.$on('item-no-longer-onstock', (payload) => {
      this.stockData = payload;
    })
  },

  beforeDestroy() {
    bus.$off('item-no-longer-onstock');
  },

  methods: {
    closeModal() {
      this.stockData = {
        modal: false,
        message: '',
      };
    },
  },
};
</script>
